















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter, Mutation } from "vuex-class";
import { API_URL } from "../global";
import { pageDataType, componentDataType, settinglinkItem } from "../types";

import {
  SET_GLOBAL_ERROR,
  SET_GLOBAL,
  SET_GLOBAL_LOADED,
  SET_SETTING_DATA,
} from "../store/mutations.names";
import {
  FETCH_GLOBAL,
  FETCH_SETTING_DATA,
  FETCH_SETTING,
} from "../store/actions.names";
import axios from "axios";
import {
  TweenMax,
  TimelineLite,
  Power3,
  Power4,
  Power1,
  Power2,
  TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";
@Component({
  name: "AddressCard",
})
export default class AddressCard extends Vue {
  @Getter("settinglink") public settinglink!: settinglinkItem[];
  @Action(FETCH_SETTING) public [FETCH_SETTING]: any;
public addAnim() {
    const add = new TimelineMax()
      .staggerFrom(
      ".sq-address-area",
        .5,
        {
          yPercent: 40,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        .05
      )
      .staggerFrom(
        ".sq-address-title",
        .4,
        {
          yPercent: 30,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.1,
        '-=.2'
      )
       .staggerFrom(
        ".sq-address",
        .4,
        {
          yPercent: 30,
          autoAlpha: 0,
          ease: Power2.easeOut,
          clearProps: "all",
        },
        0.1,
        '-=.2'
      );
      
    const controller = new ScrollMagic.Controller();
    const scene = new ScrollMagic.Scene({
      triggerElement: ".sq-address-area",
      reverse: false,
      offset: -200
    })
      .setTween(add)
      .addTo(controller);

    
  }
  
  mounted() {
    this[FETCH_SETTING]();
     if (window.matchMedia("(min-width: 1025px)").matches) {
       this.addAnim();
       }
   
  }
}
